import { render, staticRenderFns } from "./Template-3.vue?vue&type=template&id=58ca1d9e&scoped=true"
import script from "./Template-3.vue?vue&type=script&lang=js"
export * from "./Template-3.vue?vue&type=script&lang=js"
import style0 from "./Template-3.vue?vue&type=style&index=0&id=58ca1d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca1d9e",
  null
  
)

export default component.exports